<template>
    <div class="eligible-physicians-content">
        <div class="eligible-physicians-header">
            <hr class="soft" />
            <div class="eligible-physicians-header-title">
                {{ $t('pages.physicians.show.main.title') }}
            </div>
        </div>
        <div class="eligible-physicians-list">
            <div v-for="physician in physicians" :key="physician.id" class="eligible-physicians-list-item">
                <eligible-physician
                    :physician="physician"
                    :searchData="{ ...searchData, existingReferral: referral }"
                ></eligible-physician>
            </div>
            <div v-if="totalCount === 0" class="eligible-physicians-list-no-matches">
                {{ $t('pages.physicians.show.main.not_found') }}
            </div>
        </div>
        <div v-if="totalCount > limit" class="eligible-physicians-footer">
            <common-buttons>
                <common-button
                    :label="$t('pages.physicians.show.buttons.view_more')"
                    type="primary"
                    @click="viewMore"
                ></common-button>
            </common-buttons>
        </div>
    </div>
</template>

<script>
    import PhysiciansAPI from 'api/PhysiciansAPI'
    import EligiblePhysician from './EligiblePhysician'
    import ReferralMatchMixin from 'mixins/ReferralMatchMixin'

    export default {
        mixins: [ReferralMatchMixin],

        components: {
            EligiblePhysician,
        },

        props: {
            referral: { type: Object, required: true },
        },

        data() {
            return {
                physicians: null,
                limit: 3,
                searchData: this.buildReferralMatchData(
                    this.referral,
                    this.$auth.getActiveMember() && this.$auth.getActiveMember().id
                        ? this.$auth.getActiveMember().id
                        : this.$auth.getUser().id,
                ),
                totalCount: 0,
            }
        },

        methods: {
            viewMore() {
                this.goToMatchResultsPage(this.referral, this.searchData)
            },
        },

        created() {
            PhysiciansAPI.getMatchesList({ limit: this.limit, ...this.searchData }).then((results) => {
                this.physicians = results.users
                this.totalCount = parseInt(results._headers['x-total-count']) || this.physicians.length
            })
        },
    }
</script>
